import React, { useState } from 'react'
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fetchRecentStreamingDevices } from './service';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import Translate from '../../../Components/Multilanguage/Translate';
const StreamingActivity = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const theme =projectInfo?.projectConfig?.config?.THEME ;
  const [RecenDevicesData,setRecentDevicesData] = useState()
  const navigate = useNavigate()
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  useEffect(()=>{
    window.scroll(0,0)

    getRecentStreamingDevices()
  },[])

    const getRecentStreamingDevices = async () => {
        try{
            
            const response = await fetchRecentStreamingDevices(appInfo)
            if(response?.status === 200){
                setRecentDevicesData(response?.data?.data)
            }
        }catch(err){
            toast.error(err?.message, {
                position: "bottom-center",
              });
        }
    }
  return (
    <div className='streamingActivity'>
      <ToastContainer />

        <div className="wrapper">
            <h1 className="heading"><Translate textKey={'recent_device_streaming_activity'}/></h1>
            <p><Translate textKey={'used_devices_location_title'}/></p>
            <ul className="recentDeviceContainer">
                {
                    RecenDevicesData?.map((item,index)=>(
                        <li key={index} className={`recentDevice ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                            <span>{item?.location}</span>
                                <span>{item?.last_used}</span>
                        </li>

                    ))
                }
            </ul>
            <div className="buttonContainer" onClick={()=>navigate("/account")} >
                <div className="background" />
                <button className={`recentButton ${theme === 'LIGHT' ? 'light-theme' : ''}`}><Translate textKey={'done'}/></button>
            </div>
        </div>
    </div>
  )
}

export default StreamingActivity
